<template>
  <input
    :id="id"
    :checked="modelValue"
    type="checkbox"
    class="form-checkbox h-4 w-4 rounded-sm border-secondary-500 text-primary-500 focus:outline-none focus:ring-0 focus:ring-offset-0 checked:focus:border-[#e0f6e0]"
    :class="[
      size === 'small' ? 'h-[0.6875rem] w-[0.6875rem]' : '',
      size === 'medium' ? 'h-4 w-4' : '',
      size === 'large' ? 'h-6 w-6' : ''
    ]"
    :disabled="disabled"
    :required="required"
    @change="$emit('update:modelValue', $event.target.checked)"
    @click.stop
  />
</template>

<script lang="ts" setup>
const emit = defineEmits(['update:modelValue']);

interface Props {
  modelValue: boolean;
  id?: string;
  size?: 'small' | 'medium' | 'large';
  disabled?: boolean;
  required?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  size: 'medium',
  id: undefined,
  required: false
});
</script>
